// import appstore from "/src/assets/appstore.webp"
// import playstore from "/src/assets/googleplay.webp"
import { currentTheme } from "@/theme"
import { Fragment } from "react"
export const dlAppData = [
  {
    key: "ios",
    img: "/appstore.webp",
    href: currentTheme.iosDownloadLink,
  },
  {
    key: "android",
    img: "googleplay.webp",
    href: currentTheme.androidDownloadLink,
  },
]
export const renderDLAPP = ({
  onClick,
  centered = false,
  oneline = false,
}: {
  onClick?: (arg0: string) => void
  centered?: boolean
  oneline?: boolean
}) => {
  return (
    <div
      className={clsx({
        "justify-center": centered,
        "flex flex-wrap": !oneline,
        "mx-auto": oneline,
      })}
    >
      {dlAppData.map((f) => (
        <Fragment key={`footer-dl-${f.key}`}>
          <a
            className={clsx({ "flex justify-around": oneline }, "my-1")}
            target="_blank"
            href={f.href}
            onClick={() =>
              onClick && typeof onClick === "function" && onClick(f.key)
            }
          >
            <img src={f.img} />
          </a>
        </Fragment>
      ))}
    </div>
  )
}
